import React, { useState } from 'react';
import styles from './TemplatePreviewWhatsApp.module.css';
import { FaMoon, FaSun } from 'react-icons/fa';
import { ArrowLeft, Battery, Wifi, Signal, Phone, Smile, Paperclip, Mic } from 'lucide-react';

const normalizeText = (text = '') => text.replace(/\r\n/g, '\n')

const parseWhatsAppText = (text = '') => {
    const normalizedText = normalizeText(text)
    const regex = /(\*[^*]+\*)|(_[^_]+_)/g
    const tokens = []
    let lastIndex = 0
    let match

    while ((match = regex.exec(normalizedText)) !== null) {
        if (match.index > lastIndex) {
            tokens.push({ type: 'text', text: normalizedText.slice(lastIndex, match.index) })
        }
        const token = match[0]
        const content = token.slice(1, -1)
        tokens.push({ type: token.startsWith('*') ? 'bold' : 'italic', text: content })
        lastIndex = match.index + token.length
    }
    if (lastIndex < normalizedText.length) {
        tokens.push({ type: 'text', text: normalizedText.slice(lastIndex) })
    }
    return tokens
}

const renderWhatsAppText = (text = '') => {
    return normalizeText(text).split('\n').map((line, index) => {
        const parts = parseWhatsAppText(line)
        return (
            <p className={styles.lineText} key={`${line}-${index}`}>
                {parts.map((part, partIndex) => {
                    if (part.type === 'bold') {
                        return <strong key={partIndex}>{part.text}</strong>
                    }
                    if (part.type === 'italic') {
                        return <em key={partIndex}>{part.text}</em>
                    }
                    return <span key={partIndex}>{part.text}</span>
                })}
            </p>
        )
    })
}

const TemplatePreviewWhatsApp = ({ headerData, previewText }) => {
    const [darkMode, setDarkMode] = useState(false);
    const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return (
        <div className={`${styles.phoneWrapper} ${darkMode ? styles.dark : ''}`}>
            {/* Phone Frame */}
            <div className={styles.phoneFrame}>
                {/* Status Bar */}
                <div className={styles.statusBar}>
                    <div className={styles.statusRight}>
                        <Signal size={12} />
                        <Wifi size={12} />
                        <Battery size={16} className={styles.battery} />
                        <span className={styles.batteryPercent}>100%</span>
                    </div>
                </div>

                {/* WhatsApp Header */}
                <div className={styles.whatsappHeader}>
                    <div className={styles.headerLeft}>
                        <ArrowLeft size={20} className={styles.backArrow} />
                        <img
                            src="https://sm.lokaci.com/logo192.png"
                            alt="Profile"
                            className={styles.profilePic}
                        />
                        <div className={styles.contactInfo}>
                            <div className={styles.contactName}>Lokaci Pro</div>
                            <div className={styles.contactStatus}>Business Account</div>
                        </div>
                    </div>
                    <div className={styles.headerRight}>
                        <Phone size={18} />
                        <button onClick={() => setDarkMode(!darkMode)} className={styles.modeToggle}>
                            {darkMode ? <FaSun size={16} /> : <FaMoon size={16} />}
                        </button>
                    </div>
                </div>

                {/* Chat Screen */}
                <div className={styles.chatContainer}>
                    <div className={styles.messageWrapper}>
                        <div className={styles.messageBubble}>
                            {headerData?.headerType === 'image' && (
                                headerData?.headerContent ? (
                                    <img className={styles.messageImg} src={headerData.headerContent} alt="Header" />
                                ) : (
                                    <div className={styles.imagePlaceholder}>
                                        <span>📷 Image</span>
                                    </div>
                                )
                            )}
                            {headerData?.headerType === 'text' && headerData?.headerContent && (
                                <div className={styles.headerText}>{renderWhatsAppText(headerData.headerContent)}</div>
                            )}
                            {headerData?.headerType === 'video' && (
                                <div className={styles.imagePlaceholder}>
                                    <span>🎬 Video</span>
                                </div>
                            )}
                            <div className={styles.messageText}>{renderWhatsAppText(previewText)}</div>
                            <span className={styles.timestamp}>{currentTime}</span>
                        </div>
                    </div>
                </div>
                <div className={styles.messageInputBar}>
                    <button type="button" className={styles.iconButton} aria-label="Emoji">
                        <Smile size={18} />
                    </button>
                    <div className={styles.inputWrapper}>
                        <span className={styles.placeholderText}>Type a message</span>
                    </div>
                    <button type="button" className={styles.iconButton} aria-label="Attachment">
                        <Paperclip size={18} />
                    </button>
                    <button type="button" className={styles.sendButton} aria-label="Voice message">
                        <Mic size={18} />
                    </button>
                </div>
            </div>
        </div>
    )
};

export default TemplatePreviewWhatsApp;
